import { useState } from "react";
import { FaAngleDoubleRight } from "react-icons/fa";
import styles from "./Experience.module.css";

const Experience = (props) => {
  const [value, setValue] = useState(0);
  const { data } = props;
  const { company, dates, duties, title } =
    data[value];

  if (data.length > 0) {
  }

  return (
    <section
      className={styles["experience-container"]}
    >
      <ul className={styles["nav-container"]}>
        {data.map((data, index) => {
          console.log(index);
          return (
            <li
              key={data.id}
              onClick={() => setValue(index)}
              className={
                index === value
                  ? styles["active"]
                  : styles[""]
              }
            >
              {data.company}
            </li>
          );
        })}
      </ul>
      <div
        className={styles["profile-container"]}
      >
        <h2 id={styles["title"]}>{title}</h2>
        <h3 id={styles["company"]}>{company}</h3>
        <h3 id={styles["dates"]}>{dates}</h3>
        <ul className={styles["duties"]}>
          {duties.map((duty, index) => {
            return (
              <li key={index}>
                <FaAngleDoubleRight
                  id={styles["icon"]}
                />
                <p>{duty}</p>
              </li>
            );
          })}
        </ul>
        <div
          className={styles["button-container"]}
        >
          <button>More Info</button>
        </div>
      </div>
    </section>
  );
};

export default Experience;
